class ContentCardsDrawer extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.onDrawerTrigger = this.handleDrawerTrigger.bind(this)

    this.overflowContainerEl = this.externalEls['overflow-container']?.element
  }

  setupListeners () {
    super.setupListeners()

    this.externalEls.trigger?.elements?.forEach((triggerEl) => {
      triggerEl.addEventListener('click', this.onDrawerTrigger)
    })
  }

  handleDrawerTrigger (e) {
    const triggerEl = e.target.closest(this.externalEls.trigger?.selector)
    if (!triggerEl) return

    const triggerId = triggerEl.dataset.cardId

    const matchingCard = this.els.card?.elements.find((cardEl) => {
      return cardEl.dataset.cardId === triggerId
    })

    if (!matchingCard) return

    window.setTimeout(() => {
      this.overflowContainerEl?.scrollTo({
        top: matchingCard.offsetTop - this.scrollOffset,
        behavior: 'smooth',
      })
    }, this.timeoutDuration)
  }

  get scrollOffset () {
    return window.matchMedia('(max-width: 767px)').matches ? 60 : 75 // 60px / 75px
  }

  get timeoutDuration () {
    return 400 // 400ms
  }
}

if (!customElements.get('content-cards-drawer')) {
  customElements.define('content-cards-drawer', ContentCardsDrawer)
}
